import { useEffect } from "react";

export const useSecurityActions = () => {
  useEffect(() => {
    if (typeof window === "undefined") return;

    // Disable right-click
    const handleContextMenu = (e) => e.preventDefault();
    document.addEventListener("contextmenu", handleContextMenu);

    // Disable text selection
    const handleSelectStart = (e) => e.preventDefault();
    document.addEventListener("selectstart", handleSelectStart);

    // Disable drag
    const handleDragStart = (e) => e.preventDefault();
    document.addEventListener("dragstart", handleDragStart);

    // Disable key combinations
    const handleKeyDown = (e) => {
      if (
        e.key === "F12" || // DevTools
        (e.ctrlKey &&
          e.shiftKey &&
          ["I", "J", "C", "K"].includes(e.key.toUpperCase())) || // DevTools shortcuts
        (e.ctrlKey && ["S", "U", "P", "C"].includes(e.key.toUpperCase())) || // View-source, print, copy
        (e.metaKey && ["P", "S", "C"].includes(e.key.toUpperCase())) // Mac
      ) {
        e.preventDefault();
        e.stopPropagation();
      }
    };
    document.addEventListener("keydown", handleKeyDown);

    // Disable print
    const handleBeforePrint = () => {
      alert("Printing is disabled on this platform.");
    };
    window.addEventListener("beforeprint", handleBeforePrint);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("selectstart", handleSelectStart);
      document.removeEventListener("dragstart", handleDragStart);
      document.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("beforeprint", handleBeforePrint);
    };
  }, []);
};
